import { render } from "./DebugTelemetry.vue?vue&type=template&id=57365e07&scoped=true"
import script from "./DebugTelemetry.vue?vue&type=script&lang=js"
export * from "./DebugTelemetry.vue?vue&type=script&lang=js"

import "./DebugTelemetry.vue?vue&type=style&index=0&id=57365e07&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57365e07"]])

export default __exports__